<template>
  <router-btn v-if="ERPBaseAssembly == 'Standalone'" :text="$t('servicesystem.common_objects.commonterms.new')"
    :icon="'mdi-plus'" :color="'primary'" :disabled="false" :outlined="false" :textbtn="textbtn" :large="large"
    :small="small" @Press="action">
  </router-btn>
</template>

<script>
import RouterBtn from "@/components/Buttons/RouterBtn.vue";

export default {
  name: "NewCustomerBtn",
  props: ["large", "small", "textbtn"],
  components: { RouterBtn },

  data() {
    return {};
  },

  methods: {
    action() {
      this.$store.state.triggerevents.newDialogTrigger++;
    },
  },

  computed: {},

  watch: {},
};
</script>

<style lang="scss" scoped></style>
